import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const FaceNormalIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-2.892 8.458a.904.904 0 1 0 0-1.807.904.904 0 0 0 0 1.807Zm6.687-.904a.904.904 0 1 1-1.807 0 .904.904 0 0 1 1.807 0Zm-7.41 4.338c0-.4.324-.723.723-.723h5.784a.723.723 0 1 1 0 1.445H9.108a.723.723 0 0 1-.722-.722Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M9.108 11.458a.904.904 0 1 0 0-1.807.904.904 0 0 0 0 1.807ZM15.795 10.554a.904.904 0 1 1-1.807 0 .904.904 0 0 1 1.807 0ZM9.108 14.169a.723.723 0 1 0 0 1.445h5.784a.723.723 0 0 0 0-1.445H9.108Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7.265 9a7.265 7.265 0 1 1 14.53 0 7.265 7.265 0 0 1-14.53 0Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `FaceNormalIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { FaceNormalIcon };
//# sourceMappingURL=FaceNormalIcon.mjs.map
